import { render, staticRenderFns } from "./subcategoria1_listado.vue?vue&type=template&id=20b9281f"
import script from "./subcategoria1_listado.vue?vue&type=script&lang=js"
export * from "./subcategoria1_listado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports